import { Injectable } from '@angular/core';
import { ICasilla, ISesion } from '../modelos/casilla.interface';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class CasillaActualService {
  private KEYSTORAGE = "PROVIAS_CASILLA_ACTUAL";
  private KEYSTORAGE_SESSION = "PROVIAS_SESION_ACTUAL";
  private casillaActual: ICasilla;
  private sesionActual: ISesion;

  constructor(private jwtHelper: JwtHelperService) {

  }

  getCasillaActual() {
    if(!this.casillaActual) {
      let casillaActualTexto = localStorage.getItem(this.KEYSTORAGE);
      this.casillaActual = JSON.parse(casillaActualTexto);
    }

    return this.casillaActual;
  }

  setCasillaActual(casilla: ICasilla) {
    this.casillaActual = casilla;

    localStorage.setItem(this.KEYSTORAGE, JSON.stringify(this.casillaActual));
  }

  setSesion = (token: string) => {
    let sesion : ISesion = this.jwtHelper.decodeToken(token);
    //console.log(sesion);
    localStorage.setItem(this.KEYSTORAGE_SESSION, token);
    this.sesionActual = sesion;
  }

  getSesion = () : ISesion => {
    return this.sesionActual;
  }

  esSesionValida = () => {
    let token = localStorage.getItem(this.KEYSTORAGE_SESSION);
    let casillaActual = localStorage.getItem(this.KEYSTORAGE);
    return !this.jwtHelper.isTokenExpired(token) && casillaActual;
  }

  limpiarSesion = () => {
    this.sesionActual = null;
    this.casillaActual = null;
    localStorage.removeItem(this.KEYSTORAGE);
    localStorage.removeItem(this.KEYSTORAGE_SESSION);
  }
}
